<template>
  <div v-if="detail">
    <div class="section-title">申请信息</div>
    <el-descriptions :column="2" border size="small" class="detail-block">
      <el-descriptions-item label="用户UID">{{ detail.userUid || '--' }}</el-descriptions-item>
      <el-descriptions-item label="用户类型">{{ detail.userTypeName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="合伙人UID">{{ detail.topPartnerUid || '--' }}</el-descriptions-item>
      <el-descriptions-item label="用户昵称">{{ detail.nickname || '--' }}</el-descriptions-item>
      <el-descriptions-item label="Telegram账号">{{ detail.telegramAccount || '--' }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ detail.approvalStatusName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{ formatTime(detail.createTime) }}</el-descriptions-item>
      <el-descriptions-item label="发放卡券">{{ couponText(detail) }}</el-descriptions-item>
      <el-descriptions-item label="VIP等级">{{ detail.vipLevel ? `VIP${detail.vipLevel}` : '--' }}</el-descriptions-item>
    </el-descriptions>
    <div class="section-title">上传证明</div>
    <div v-if="photos.length" class="photo-list">
      <el-image
        v-for="url in photos"
        :key="url"
        class="photo"
        :src="url"
        :preview-src-list="photos"
        fit="cover"
      />
    </div>
    <div v-else class="empty-photo">--</div>
  </div>
</template>

<script>
export default {
  name: 'VipMigrationTrialCardApprovalDetailBlock',
  props: {
    detail: Object,
  },
  computed: {
    photos() {
      if (!this.detail) return [];
      if (Array.isArray(this.detail.photoUrlList)) return this.detail.photoUrlList.filter(Boolean);
      if (!this.detail.photoUrls) return [];
      return String(this.detail.photoUrls).split(',').map((item) => item.trim()).filter(Boolean);
    },
  },
  methods: {
    couponText(detail) {
      if (!detail || !detail.couponName) return '--';
      return detail.couponNo ? `${detail.couponName}(${detail.couponNo})` : detail.couponName;
    },
    formatTime(value) {
      if (!value) return '--';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return '--';
      const p = (x) => String(x).padStart(2, '0');
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
  },
};
</script>

<style scoped>
.section-title {
  margin: 14px 0 10px;
  font-weight: 600;
  color: #1f2f5f;
}
.detail-block {
  margin-bottom: 12px;
}
.photo-list {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.photo {
  width: 190px;
  height: 120px;
  border: 1px solid #d9e2f2;
  border-radius: 4px;
  background: #f7f9fc;
}
.empty-photo {
  color: #909399;
}
</style>
